import { jsx } from 'react/jsx-runtime';
import { Modal as Modal$1 } from 'baseui/modal';
import { mergeOverrides } from '../../overrides.js';
import 'react';
import 'baseui';
import '../../theme/olx-theme/base-theme.js';
import '../../theme/olx-theme/theme.js';
import { useResolvedStyle, mergeStyles } from '../../theme/utils.js';
import '../../theme/types.js';
import { CloseButton } from './close-button.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getStyles = ({ $theme, $size }, element) => {
  switch (element) {
    case "Dialog":
      return __spreadProps(__spreadValues({
        maxWidth: $size !== "full" && typeof $size !== "number" ? "704px" : void 0,
        marginTop: $theme.space[64],
        marginRight: $theme.space[16],
        marginBottom: $theme.space[64],
        marginLeft: $theme.space[16],
        borderTopLeftRadius: $theme.radii[4],
        borderTopRightRadius: $theme.radii[4],
        borderBottomRightRadius: $theme.radii[4],
        borderBottomLeftRadius: $theme.radii[4],
        transitionDuration: $theme.animation.duration[150]
      }, $size === "full" && {
        marginTop: 0,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0
      }), {
        [$theme.mediaQuery.lg]: __spreadValues({}, $size === "full" && {
          marginTop: $theme.space[16],
          marginRight: $theme.space[16],
          marginBottom: $theme.space[16],
          marginLeft: $theme.space[16]
        })
      });
    case "DialogContainer":
      return {
        backgroundColor: `${$theme.colors["background-brand-primary"]}cc`,
        transitionDuration: $theme.animation.duration[150]
      };
    case "Close":
      return {
        top: $theme.space[24],
        right: $theme.space[24],
        color: $theme.palettes.gray.charcoal,
        borderRadius: $theme.radii[4],
        ":focus": $theme.focusOutline
      };
    case "Root":
    default:
      return {
        zIndex: $theme.zIndices.modal
      };
  }
};
const Modal = (_a) => {
  var _b = _a, { overrides, $style } = _b, props = __objRest(_b, ["overrides", "$style"]);
  const resolvedStyles = useResolvedStyle($style);
  return jsx(Modal$1, __spreadValues({ overrides: mergeOverrides({
    Root: {
      style: (styleProps) => mergeStyles(getStyles(styleProps, "Root"), resolvedStyles)
    },
    Dialog: { style: (styleProps) => getStyles(styleProps, "Dialog") },
    DialogContainer: { style: (styleProps) => getStyles(styleProps, "DialogContainer") },
    Close: { style: (styleProps) => getStyles(styleProps, "Close"), component: CloseButton }
  }, overrides) }, props));
};

export { Modal };
